// Slide 1 - Intro Slide
export default function Slide1() {
  return (
    <div className="text-center max-w-6xl relative z-10 px-2 sm:px-4 md:px-6">
      <div className="absolute -left-24 -top-10 opacity-40 pointer-events-none hidden md:block">
        <div
          style={{
            width: 380,
            height: 380,
            borderRadius: "50%",
            filter: "blur(80px)",
            background:
              "linear-gradient(135deg, rgba(30,64,175,0.36), rgba(67,56,202,0.16))",
          }}
        />
      </div>

      <div className="mb-3 sm:mb-4 md:mb-8 inline-block">
        <div className="w-20 h-20 sm:w-28 sm:h-28 md:w-36 md:h-36 mx-auto bg-white/6 backdrop-blur-xl rounded-2xl md:rounded-3xl border-2 border-white/20 flex items-center justify-center shadow-2xl transform transition-transform duration-700 hover:scale-105">
          <div className="bg-white rounded-lg md:rounded-xl p-0.5 md:p-1 shadow-sm">
            <img
              src="/logo.png"
              alt="Trinaski Labs Logo"
              className="w-16 h-16 sm:w-24 sm:h-24 md:w-28 md:h-28 object-contain"
            />
          </div>
        </div>
      </div>

      <h1
        className="text-white font-extrabold leading-tight mb-2 sm:mb-3 md:mb-4 drop-shadow-2xl"
        style={{
          fontSize: "clamp(36px, 11vw, 110px)",
          letterSpacing: "-0.03em",
        }}
      >
        Trinaski Labs
      </h1>

      <div className="mx-auto max-w-3xl">
        <p
          className="text-white/90 font-medium drop-shadow-lg mb-3 sm:mb-4 md:mb-6"
          style={{ fontSize: "clamp(16px, 4vw, 26px)", lineHeight: 1.4 }}
        >
          We turn your <span className="keyword">vision</span> into{" "}
          <span className="keyword">scalable</span> digital products —
          design-led, engineering-driven, and built for growth.
        </p>

        {/* CTAs removed as requested */}

        <div className="flex items-center justify-center gap-2 sm:gap-3 md:gap-6 flex-wrap">
          <div className="inline-flex items-center gap-1.5 sm:gap-2 md:gap-3 text-white/90 bg-white/5 px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full">
            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-emerald-400 rounded-full" />
            <span className="text-xs sm:text-sm md:text-base">Website Development</span>
          </div>
          <div className="inline-flex items-center gap-1.5 sm:gap-2 md:gap-3 text-white/90 bg-white/5 px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full">
            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-indigo-400 rounded-full" />
            <span className="text-xs sm:text-sm md:text-base">Product Development</span>
          </div>
          <div className="inline-flex items-center gap-1.5 sm:gap-2 md:gap-3 text-white/90 bg-white/5 px-2 sm:px-3 md:px-4 py-1 sm:py-1.5 md:py-2 rounded-full">
            <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-sky-400 rounded-full" />
            <span className="text-xs sm:text-sm md:text-base">End-to-end</span>
          </div>
        </div>
      </div>
    </div>
  );
}
